import { Injectable } from '@angular/core';

/*
  Generated class for the PhonesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ModelsProvider {
  models: any = null;
  constructor() {
    // console.log('Hello ModelsProvider Provider');
  }

  getAllModels(){
    if(this.models == null){
      this.models = {};
      this.initCrop();
      this.initPhones();
      this.initTablets();
      this.initDesktops();
      this.initWatchs();
      this.initIcons();
      this.initCrop();
    }

    // console.log("getModels",this.models);
    return this.models;
  }

  getModels(type){
    if(this.models == null){
      this.models = {};
      this.initCrop();
      this.initPhones();
      this.initTablets();
      this.initDesktops();
      this.initWatchs();
      this.initIcons();
    }

    // console.log("getModels",this.models);
    return this.models[type];
  }
  getModel(type, index){
    if(this.models == null){
      this.models = {};
      this.initPhones();
      this.initCrop();
      this.initTablets();
      this.initDesktops();
      this.initWatchs();
      this.initIcons();
    }
    return this.models[type][index];
  }

  initPhones(){
    this.models["phones"] = [];
    this.initIphoneMinimal();
    this.initIphoneX();
    this.initIphoneXBorder();
  }

  initCrop(){
    this.models["crop"] = [];
    this.initIphoneXCrop();
    this.initIphoneCrop();
    this.initTabletCrop();
    this.initDesktopCrop();
  }

  // TABLETS
  initTablets(){
    this.models["tablets"] = [];
    this.initIpadClear();
    this.initIpadBorder();
    this.initIpadProBorder();
    this.initIpadAir();
    this.initIpadClearLandscape();
    this.initIpadAirLandscape();
  }

  initIpadClear(){
    this.models["tablets"].push({
      index:0,
      type:"tablets",
      title: "Ipad Clear",
      name: "ipad_clear",
      size:{
        width:746,
        height:1024,
        ratio:746/1024
      },
      resolution: {
        width:768,
        height:1024
      },
      border: {
        top:69,
        right:44,
        bottom:78,
        left:44
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_clear_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_clear_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }


  initIpadBorder(){
    this.models["tablets"].push({
      index:2,
      type:"tablets",
      title: "Ipad Border",
      name: "ipad_border",
      size:{
        width:746,
        height:1024,
        ratio:746/1024
      },
      resolution: {
        width:768,
        height:1024
      },
      border: {
        top:69,
        right:44,
        bottom:78,
        left:44
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_clear_border_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_clear_border_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }


  initIpadProBorder(){
    this.models["tablets"].push({
      index:3,
      type:"tablets",
      title: "Ipad Pro Border",
      crop: "ipad_pro",
      name: "ipad_pro_border",
      size:{
        width:1024,
        height:1366,
        ratio:1024/1366
      },
      resolution: {
        width:1024,
        height:1366
      },
      border: {
        top:40,
        right:40,
        bottom:40,
        left:40
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_pro_border_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_pro_border_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }


  initIpadAir(){
    this.models["tablets"].push({
      index:1,
      title: "Ipad Air",
      name: "ipad_air",
      type:"tablets",
      size:{
        width:729,
        height:1024,
        ratio:729/1024
      },
      resolution: {
        width:768,
        height:1024
      },
      border: {
        top:110,
        right:63,
        bottom:110,
        left:63
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_air_space_gray.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_air_gold.png",
          name: "Gold",
          code: "#efac56",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_air_silver.png",
          name: "Silver",
          code: "#f4F4F4",
          type: "black"
        }
      ]
    });
  }


  initIpadClearLandscape(){
    this.models["tablets"].push({
      index:0,
      title: "Ipad Clear Landscape",
      name: "ipad_clear_landscape",
      type:"tablets",
      size:{
        width:1024,
        height:746,
        ratio:1024/746
      },
      resolution: {
        width:1024,
        height:768
      },
      border: {
        top:44,
        right:78,
        bottom:44,
        left:69
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_clear_black_landscape.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_clear_white_landscape.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }


  initIpadAirLandscape(){
    this.models["tablets"].push({
      index:1,
      title: "Ipad Air",
      name: "ipad_air",
      type:"tablets",
      size:{
        width:1024,
        height:729,
        ratio:1024/729
      },
      resolution: {
        width:1024,
        height:768
      },
      border: {
        top:63,
        right:110,
        bottom:63,
        left:110
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/tablets/ipad_air_space_gray_landscape.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_air_gold_landscape.png",
          name: "Gold",
          code: "#efac56",
          type: "black"
        },
        {
          src:"assets/models/tablets/ipad_air_silver_landscape.png",
          name: "Silver",
          code: "#f4F4F4",
          type: "black"
        }
      ]
    });
  }

  // DESKTOPS
  initDesktops(){
    this.models["desktops"] = [];
    this.initMacbookAirClear();
    this.initMacbookProClear();
    this.initMacbookGold();
    this.initImacClear();
    this.initImacRetina();
    this.initDell_XPS();
  }


  initMacbookAirClear(){
    this.models["desktops"].push({
      index:0,
      title: "Macbook Air Clear",
      name: "macbook_air_clear",
      type:"desktops",
      size:{
        width:1019,
        height:592,
        ratio:1019/592
      },
      resolution: {
        width:2038,
        height:1184,
      },
      border: {
        top:44,
        right:128,
        bottom:71,
        left:127
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/macbook_air_clear_black.png",
          name: "Black",
          code: "#000",
          type: "black"
        },{
            src:"assets/models/desktops/macbook_air_clear_black_white.png",
            name: "White",
            code: "#FFF",
            type: "white"
        }
      ]
    });
  }


  initMacbookProClear(){
    this.models["desktops"].push({
      index:0,
      title: "Macbook Pro Clear",
      name: "macbook_pro_clear",
      type:"desktops",
      size:{
        width:1024,
        height:596,
        ratio:1024/596
      },
      resolution: {
        width:2038,
        height:1184,
      },
      border: {
        top:35,
        right:121,
        bottom:72,
        left:122
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/macbookpro_clear.png",
          name: "Black",
          code: "#000",
          type: "black"
        }
      ]
    });
  }

  initMacbookGold(){
    this.models["desktops"].push({
      index:0,
      title: "Macbook Gold",
      name: "macbook_gold",
      type:"desktops",
      size:{
        width:1024,
        height:601,
        ratio:1024/601
      },
      border: {
        top:42,
        right:126,
        bottom:77,
        left:126
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/macbook_gold.png",
          name: "gold",
          code: "#efac56",
          type: "black"
        }
      ]
    });
  }

  initImacClear(){
    this.models["desktops"].push({
      index:0,
      title: "Imac Clear",
      name: "imac_clear",
      type:"desktops",
      size:{
        width:1024,
        height:848,
        ratio:1024/848
      },
      border: {
        top:45,
        right:43,
        bottom:276,
        left:43
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/imac_clear_black.png",
          name: "Black",
          code: "#000",
          type: "white"
        },{
            src:"assets/models/desktops/imac_clear_gray.png",
            name: "Gray",
            code: "#393939",
            type: "black"
          },{
          src:"assets/models/desktops/imac_clear_white.png",
          name: "White",
          code: "#fff",
          type: "white"
        }
      ]
    });
  }


  initImacRetina(){
    this.models["desktops"].push({
      index:0,
      title: "Imac Retina",
      name: "imac_retina",
      type:"desktops",
      size:{
        width:1024,
        height:861,
        ratio:1024/861
      },
      border: {
        top:54,
        right:41,
        bottom:277,
        left:41
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/imac_retina.png",
          name: "Black",
          code: "#000",
          type: "black"
        }
      ]
    });
  }

  initDell_XPS(){
    this.models["desktops"].push({
      index:0,
      title: "Dell XPS",
      name: "dell_xps",
      type:"desktops",
      size:{
        width:1024,
        height:546,
        ratio:1024/546
      },
      border: {
        top:25,
        right:133,
        bottom:94,
        left:133
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/desktops/dell_xps.png",
          name: "Black",
          code: "#000",
          type: "black"
        }
      ]
    });
  }

  // WATCHS
  initWatchs(){
    this.models["watchs"] = [];
    this.initAppleWatch();
  }

  initAppleWatch(){
    this.models["watchs"].push({
      index:0,
      title: "Apple Watch",
      name: "apple_watch",
      type:"watchs",
      size:{
        width:600,
        height:1024,
        ratio:600/1024
      },
      border: {
        top:263,
        right:95,
        bottom:263,
        left:94
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/watchs/apple_watch_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/watchs/apple_watch_white.png",
          name: "White",
          code: "#F4F4F4",
          type: "white"
        },
        {
          src:"assets/models/watchs/apple_watch_silver_nike.png",
          name: "Siver Nike",
          code: "#E6ED75",
          type: "white"
        },
        {
          src:"assets/models/watchs/apple_watch_silver.png",
          name: "Silver",
          code: "#FFFFFF",
          type: "white"
        },
        {
          src:"assets/models/watchs/apple_watch_space_gray.png",
          name: "space_gray",
          code: "#393939",
          type: "black"
        }
      ]
    });
  }


  // ICONS
  initIcons(){
    this.models["icons"] = [];
    this.initIconClear();
  }
  initIconClear(){

    this.models["icons"].push({
      index:0,
      title: "Ios Icon Clear",
      name: "icon_app_store",
      crop : "ios_icon",
      type:"icons",
      size:{
        width:1024,
        height:1024,
        ratio:1024/1024
      },
      resolution: {
        width:1024,
        height:1024,
      },
      border: {
        top:0,
        right:0,
        bottom:0,
        left:0
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/icons/icon_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });

  }

  // IPHONES

  initIphoneMinimal(){
    this.models["phones"].push({
      index:0,
      title: "iPhone Minimalist",
      name: "iphone_minimalist",
      type:"phones",
      size:{
        width:809,
        height:1621,
        ratio:809/1621
      },
      border: {
        top:139,
        right:25,
        bottom:184,
        left:25
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [{
          src:"assets/models/phones/iphone_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },
        {
          src:"assets/models/phones/iphone_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }

  initIphoneX(){
    this.models["phones"].push({
      index:1,
      title: "iPhone X",
      name: "iphonex",
      type:"phones",
      size:{
        width:859,
        height:1724,
        ratio:859/1724
      },
      border: {
        top:49,
        right:54,
        bottom:49,
        left:54
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [
        {
          src:"assets/models/phones/iphonex_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },{
          src:"assets/models/phones/iphonex_gray.png",
          name: "Gray",
          code: "#c4c4c4",
          type: "colored"
        },{
          src:"assets/models/phones/iphonex_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }


  initIphoneXBorder(){
    this.models["phones"].push({
      index:2,
      title: "iPhone X Border",
      name: "iphonexborder",
      crop : "iphone_x",
      type:"phones",
      size:{
        width:859,
        height:1724,
        ratio:859/1724
      },
      border: {
        top:49,
        right:54,
        bottom:49,
        left:54
      },
      position:[{
        title:'Middle',
        name:'middle',
        left:0,
        top:0,
      },{
        title:'Top',
        name:'top',
        left:0,
        top:-500,
      },{
        title:'Bottom',
        name:'bottom',
        left:0,
        top:500,
      }],
      colors: [
        {
          src:"assets/models/phones/iphonex_border_black.png",
          name: "Black",
          code: "#000000",
          type: "black"
        },{
          src:"assets/models/phones/iphonex_border_white.png",
          name: "White",
          code: "#FFFFFF",
          type: "white"
        }
      ]
    });
  }

  // CROP

  initIphoneXCrop(){
    this.models["crop"].push({
      index:0,
      title: "Iphone X Clean",
      name: "iphonex_crop",
      crop : "iphone_x",
      type:"phones",
      size:{
        width:859,
        height:1724,
        ratio:859/1724
      },
      border: {
        top:49,
        right:54,
        bottom:49,
        left:54
      },
      colors: [{
          src:"assets/models/phones/iphonex_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });
  }



  initIphoneCrop(){
    this.models["crop"].push({
      index:0,
      title: "Iphone",
      name: "iphone_crop",
      crop : "iphone",
      type:"phones",
      size:{
        width:809,
        height:1621,
        ratio:809/1621
      },
      resolution: {
        width:759,
        height:1298,
        raio: 1.71
      },
      border: {
        top:139,
        right:25,
        bottom:184,
        left:25
      },
      colors: [{
          src:"assets/models/phones/iphone_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });
  }

  initTabletCrop(){
    this.models["crop"].push({
      index:0,
      title: "Tablet landscape",
      name: "tablet_crop",
      crop : "rectangle",
      type:"crop",
      size:{
        width:1200,
        height:900,
        ratio:1200/900
      },
      border: {
        top:100,
        right:100,
        bottom:100,
        left:100
      },
      colors: [{
          src:"assets/models/phones/iphonex_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });

    this.models["crop"].push({
      index:0,
      title: "Tablet portrait",
      name: "tablet_crop",
      crop : "rectangle",
      type:"crop",
      size:{
        width:900,
        height:1200,
        ratio:900/1200
      },
      border: {
        top:100,
        right:100,
        bottom:100,
        left:100
      },
      colors: [{
          src:"assets/models/phones/iphonex_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });
  }

  initDesktopCrop(){
    this.models["crop"].push({
      index:0,
      title: "Desktop",
      name: "desktop_crop",
      crop : "rectangle",
      type:"crop",
      size:{
        width:960,
        height:600,
        ratio:960/600
      },
      border: {
        top:100,
        right:100,
        bottom:100,
        left:100
      },
      colors: [{
          src:"assets/models/phones/iphonex_clear.png",
          name: "Clear",
          code: "#f4f4f4",
          type: "clear"
        }
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/models/models.ts